/*** IMPORTS FROM imports-loader ***/
(function() {

define([
  'jquery',
  'mustache',
  'velocity',
  'pip-model',
  'plugin.tooltip',
  'pip-common.utils',
],
  function pipBuyboxHdpp(
    $,
    Mustache,
    velocity,
    pip,
    tooltip,
    utils
  ) {
    var view = {
      templates: {
        hdppAddOn: $('#hdpp-add-on-template').html(),
        hdppMultiAddOn: $('#hdpp-multi-add-on-template').html(),
        hdppTooltip: $('#hdpp-tooltip-template').html()
      },
      selectors: {
        hdppSection: '#add-on__container',
        optInCheckbox: '.buybox__protection-plan__optin',
        whatToExpect: '#buyBox-hdpp .buybox__add-on__learn-more-cta'
      },
      determineTemplates: function determineTemplates(addOns) {
        this.template = view.templates.hdppAddOn;
        this.container = view.selectors.hdppSection;

        if (addOns && addOns.multipleAddOns && addOns.side) {
          this.template = view.templates.hdppMultiAddOn;
          this.container = '#multi-add-on-' + addOns.side;
        }
      }
    }


    function isProtectionPlanAddOnDisplayable() {
      return pip.protectionPlan && !pip.products.primary.data.itemAvailability.discontinuedItem;
    }

    function initEventListeners() {
      $(document).off('.hdpp');
      $(document).on('click.hdpp', view.selectors.optInCheckbox, function (e) {
        $(this).toggleClass('checkbox-custom-active');
        pip.customer.isOptedIntoHdpp = $(this).is(':checked');
      });

      var tooltipOptions = {
        type: 'click',
        position: 'bottom',
        content: function () {
          return Mustache.to_html(view.templates.hdppTooltip, { planDetailsUrl: pip.protectionPlan.detailsUrl || '' });
        },
        width: utils.getTooltipSize(),
        closeButton: true,
        bestPosition: false,
        closeOnClick: true
      };
      $(view.selectors.whatToExpect).tooltip(tooltipOptions);
    }

    return {
      init: function init(addOns) {
        if (!isProtectionPlanAddOnDisplayable()) return;

        view.determineTemplates(addOns);
        $(view.container).html(Mustache.render(view.template, pip.protectionPlan)).velocity('slideDown', { duration: 300 });

        initEventListeners();
      },

      isProtectionPlanAddOnDisplayable: isProtectionPlanAddOnDisplayable
    };
  });

}.call(window));